<script>
  import Avatar from '@components/Avatar.svelte';

  export let user;
  export let width = 27;
</script>

{#if user.id}
  <Avatar href={user.profile_path} src={user.avatar_url} width={width} user={user} />
{:else}
  <Avatar src={'/images/user-placeholder.png'} width={width} />
{/if}
